import "./it-consulting-services.css";
import { useNavigate } from "react-router-dom";
import useLocalizedPath from "../../../components/use-localized-path";
import Timeline from "../../../components/timeline/timeline-comp";
import { useTranslation } from "react-i18next";

export default function ItConsultingServices() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const localize = useLocalizedPath();
  const goToContact = () => {
    navigate(localize("/contact-us"));
  };

  const goToAbout = () => {
    navigate(localize("/about-us"));
  };

  const timelineData = [
    {
      date: "01",
      title: "IT Infrastructure Optimization",
      content: "Strategic planning for IT infrastructure optimization.",
    },
    {
      date: "02",
      title: "Operational Efficiency",
      content: "Streamlined processes and improved operational efficiency.",
    },
    {
      date: "03",
      title: "Technology Recommendations",
      content: "Cost-effective technology recommendations.",
    },
    {
      date: "04",
      title: "Data Security & Protection",
      content: "Enhanced security and data protection measures.",
    },
    {
      date: "05",
      title: "Scalable Growth Solutions",
      content: "Scalable solutions that adapt to your organization's growth.",
    },
  ];

  const challenges = [
    {
      number: "01",
      text: "IT challenges in rapidly evolving digital landscape.",
    },
    {
      number: "02",
      text: "Outdated infrastructure, inefficient processes, and inadequate technology utilization.",
    },
    {
      number: "03",
      text: "Hinders growth, reduces productivity, and limits competitive advantage.",
    },
  ];

  const cards = [
    {
      icon: "fa-solid fa-users-gear",
      title: "Collaborative IT Analysis",
      text: "Collaborative analysis of IT infrastructure, processes, and goals.",
    },
    {
      icon: "fa-solid fa-magnifying-glass-chart",
      title: "Identifying System Flaws",
      text: "Identifying gaps, inefficiencies, and areas for improvement.",
    },
    {
      icon: "fa-solid fa-diagram-project",
      title: "Tailoring IT Strategy",
      text: "Developing a comprehensive, tailored IT strategy.",
    },
  ];

  return (
    <div className="main-container">
      {/* main image section */}
      <section className="main-image-section it-consulting-services-section">
        <div className="main-image-dark-effect">
          <p className="sub-container-sub-heading">{t("Services")}</p>
          <h1 className="sub-container-heading">{t("IT Consulting Services")}</h1>
          <p className="sub-container-desc">
            {t("Strategic IT consultation to streamline technology adoption, optimize workflows, and align IT with business objectives empowering organizations to enhance performance, reduce operational costs, and accelerate digital transformation.")}
          </p>
          <div className="main-img-container-buttons">
            <button
              type="button"
              className="img-contact-btn common-btn-styles"
              onClick={goToContact}
            >
              {t("Contact Us")}
            </button>
            <button
              type="button"
              className="img-about-btn common-btn-styles"
              onClick={goToAbout}
            >
              {t("About Us")}
            </button>
          </div>
        </div>
      </section>

      {/* service overview section */}
      <section className="service-overview">
        <div className="service-overview-width sub-container">
          <div>
            <h2 className="sub-container-heading">{t("Service Overview")}</h2>
          </div>

          <div className="service-img-container">
            <div className="service-image">
              <img
                src="/assets/images/it-consulting-services-overview.webp"
                alt={t("It Consulting Services Overview")}
              />
            </div>

            {/* Right Content */}
            <div className="service-content">
              <p>
                {t("Empowering businesses with expert IT consulting to streamline operations, enhance performance, and align technology with strategic goals for sustainable growth.")}
              </p>
              <ul>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("Comprehensive IT consulting services to empower your organization.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("A synergistic approach integrating strategic planning, process optimization, and technology recommendations.")}
                </li>
                <li>
                  <i className="fa-solid fa-angles-right"></i> {t("Tailored solutions addressing unique challenges for business growth.")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/*challenges secton*/}
      <section className="challenges-section sub-container">
        <h2 className="sub-container-heading">{t("Challenges")}</h2>
        <p className="sub-container-desc">
          {t("Common IT Consulting challenges organizations face in today’s digital landscape.")}
        </p>

        <div className="challenges-container">
          {challenges.map((item, index) => (
            <div
              className="challenge-box"
              key={index}
              data-number={item.number}
            >
              <p className="challenge-text">{t(item.text)}</p>
            </div>
          ))}
        </div>
      </section>

      {/* how are we solving section */}
      <section className="solving-section">
        <div className="solving-section-container sub-container">
          <h2 className="sub-container-heading">{t("How Are We Solving")}</h2>
          <p className="sub-container-desc">
            {t("We combine strategic insight, technical expertise, and collaboration to deliver IT consulting services that help businesses optimize performance, enhance efficiency, and make smarter, technology-driven decisions.")}
          </p>

          <div className="solving-cards">
            {cards.map((card, index) => (
              <div className="solving-card" key={index}>
                <div className="icon-wrapper">
                  <i className={card.icon}></i>
                </div>
                <h3>{t(card.title)}</h3>
                <p>{t(card.text)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* benefits section */}
      <section className="benefits-section sub-container">
        <h2 className="sub-container-heading">{t("Benefits")}</h2>
        <p className="sub-container-desc">
          {t("With the quality and approach, we would be delivering the best of what you’d need in consulting, suggesting, providing right solutions thus yielding best benefits for your organizations productivity.")}
        </p>
        <div>
          <Timeline timelineData={timelineData} />
        </div>
      </section>
    </div>
  );
}
